import { ModalWindow } from '@cian/ui-kit';

import { FC } from 'react';

import { useCardComplaintContext } from 'shared/context/CardComplaintContext';

import { ComplaintModalContent } from './internal/components/ComplaintModalContent';

export const ComplaintFlow: FC = () => {
  const { isModalOpen, onModalClose } = useCardComplaintContext();

  return (
    <ModalWindow
      content={isModalOpen && <ComplaintModalContent onClose={onModalClose} />}
      open={isModalOpen}
      size="XS"
      width={600}
      onClose={onModalClose}
    />
  );
};
